"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColor = void 0;
var getColor = function (_a) {
    var currentCount = _a.currentCount, maxCount = _a.maxCount;
    switch (true) {
        case currentCount === maxCount: {
            return 'yellow-600';
        }
        case currentCount > maxCount: {
            return 'utility-error';
        }
        default: {
            return 'grey-600';
        }
    }
};
exports.getColor = getColor;
//# sourceMappingURL=get-color.js.map